// hook to get the screen size using tailwind config and react-responsive
import { useMediaQuery } from 'react-responsive'
import resolveConfig from 'tailwindcss/resolveConfig'
import type { Config } from 'tailwindcss/types/config'

import tailwindConfig from '../../tailwind.config'

const fullConfig = resolveConfig(tailwindConfig as unknown as Config)
type Size = 'sm' | 'md' | 'lg' | 'xl' | '2xl'
type ScreenSize = {
  is2xl: boolean,
  isXl: boolean,
  isLg: boolean,
  isMd: boolean,
  isSm: boolean,
  isXs: boolean,
  isSmallerOrEqual: (size: Size) => boolean
  isBiggerOrEqual: (size: Size) => boolean
}

const useScreenSize = (): ScreenSize => {
  const is2xl = useMediaQuery({ minWidth: fullConfig.theme.screens['2xl'] })
  const isXl = useMediaQuery({ minWidth: fullConfig.theme.screens.xl })
  const isLg = useMediaQuery({ minWidth: fullConfig.theme.screens.lg })
  const isMd = useMediaQuery({ minWidth: fullConfig.theme.screens.md })
  const isSm = useMediaQuery({ minWidth: fullConfig.theme.screens.sm })
  const isXs = useMediaQuery({ maxWidth: fullConfig.theme.screens.sm })

  const isSmallerOrEqual = (size: Size) => {
    const screenSize = fullConfig.theme.screens[size]
    return useMediaQuery({ maxWidth: screenSize })
  }

  const isBiggerOrEqual = (size: Size) => {
    const screenSize = fullConfig.theme.screens[size]
    return useMediaQuery({ minWidth: screenSize })
  }

  return { is2xl, isXl, isLg, isMd, isSm, isXs, isSmallerOrEqual, isBiggerOrEqual }
}

export default useScreenSize
